import { useEffect, useState } from 'react'

/**
 * Простой external store для "у Pavel есть непрочитанное сообщение".
 * Используется для красной точки на иконке бота в нижнем меню.
 *
 * Состояние живёт в памяти + localStorage (чтобы переживало перезагрузку
 * страницы). EventTarget сигнализирует подписчикам об изменениях.
 */
const STORAGE_KEY = 'tfa:pavel-unread'
const bus = new EventTarget()

function read(): boolean {
  if (typeof window === 'undefined') return false
  try {
    return window.localStorage.getItem(STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

function write(value: boolean) {
  if (typeof window === 'undefined') return
  try {
    if (value) window.localStorage.setItem(STORAGE_KEY, '1')
    else window.localStorage.removeItem(STORAGE_KEY)
  } catch {
    /* ignore */
  }
  bus.dispatchEvent(new Event('change'))
}

export function setPavelUnread(value: boolean) {
  write(value)
}

export function getPavelUnread(): boolean {
  return read()
}

export function usePavelUnread(): boolean {
  const [unread, setUnread] = useState<boolean>(() => read())

  useEffect(() => {
    const handler = () => setUnread(read())
    bus.addEventListener('change', handler)
    // Sync between tabs via storage event
    const storageHandler = (e: StorageEvent) => {
      if (e.key === STORAGE_KEY) setUnread(read())
    }
    window.addEventListener('storage', storageHandler)
    return () => {
      bus.removeEventListener('change', handler)
      window.removeEventListener('storage', storageHandler)
    }
  }, [])

  return unread
}
